import router from "./router";
import store from "./store";
import createRoutes from "@/util/createRoutes";

// 是否有菜单数据
let hasMenus = false;
router.beforeEach(async (to, from, next) => {
  console.log(to.path);
  if (to.path === "/") {
    next({ path: "/login" });
    return;
  }
  if (to.path === "/login") {
    store.commit("initMenuItems", []);
    next();
    return;
  }
  const hasRoles =
    typeof store.state.menuItems != "undefined" &&
    store.state.menuItems.length > 0;
  if (!hasRoles) {
    const { menuData, permissionData } = await store.dispatch("getInfo");
  }
  if (!hasMenus && !hasRoles) {
    const routes = createRoutes(store.state.menuItems);
    //动态添加路由
    router.addRoutes(routes);
    console.log(router.getRoutes());
    hasMenus = true;
    next({ path: to.path || "/" });
    return;
  }
  next();
});



// WEBPACK FOOTER //
// ./src/permission.js